import React from 'react';
import styled, { css } from 'styled-components';
import { BlockLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { LinkButton, useEntity, useLang, ContentEntityContent } from '@shapeable/ui';
import { MetricLayout } from '../entities/metric-layout';
import { ImageValueIntro } from '../entities/image-value-intro';
import { useSite } from '../../hooks/use-site';
import { coalesce, firstStringProperty } from '@shapeable/utils';
import { DottedChevronRightHeavyIconGlyph } from '@shapeable/icons';

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const BodyStyles = breakpoints({
  base: css`
    margin-top: ${theme.UNIT(8)};
  `,
});

const ButtonStyles = breakpoints({
  base: css`
    flex-grow: 1;
  `,
});



// -------- Components -------->

const My = {
  Container: styled(MetricLayout)<ContainerProps>`${ContainerStyles}`,
  Body: styled(ImageValueIntro)`${BodyStyles}`,
  Button: styled(LinkButton)`${ButtonStyles}`,
};

export const BlockLayoutCountCitations: BlockLayoutComponent = (props) => {
  const { className, children } = props;
  const entity = useEntity(props.entity);
  const { metrics } = useSite();
  const t = useLang();
  const { countCitations } = metrics;
  const linkHref = firstStringProperty(entity, ['link.page.path', 'links.url']);
  const { title, image } = entity;

  return (
    <My.Container
      entity={entity} 
      className={className}
      controls={
        <My.Button variant='slim' href={linkHref} icon={DottedChevronRightHeavyIconGlyph}>{t('View All Papers')}</My.Button>
      }
    >
      <My.Body value={countCitations} entity={entity} />
    </My.Container>
  )
};